import { Vue, Component, Prop } from 'vue-property-decorator';
import NavigationItem from '../navigation-item/navigation-item.vue';
import { createNamespacedHelpers } from 'vuex';
import { NodeData, TreeNode } from 'store';
import WithVersionValidator from '@/modules/versioning/components/with-version-validator/with-version-validator.vue';
import NavigationSectionHeader from '../navigation-section-header/navigation-section-header.vue';
import types from '@/modules/navigation/store/mutations-types';

const { mapActions, mapMutations } = createNamespacedHelpers('navigation');

@Component({
	name: 'navigation-node',

	components: {
		'navigation-item': NavigationItem,
		'with-version-validator': WithVersionValidator,
		'navigation-section-header': NavigationSectionHeader
	},

	methods: {
		...mapActions(['hideAllSubMenus']),
		...mapMutations({
			updateNavigationItem: types.UPDATE_NAVIGATION_ITEM
		})
	}
})
export default class NavigationNode extends Vue {
	@Prop()
	readonly tree!: TreeNode;

	@Prop()
	readonly data!: NodeData;

	@Prop({
		default: 'div'
	})
	readonly rootTag!: string;

	@Prop({
		default: 'navigation-section-header'
	})
	readonly sectionHeaderComponent!: string;

	@Prop({
		default: 'navigation-item'
	})
	readonly navigationItemComponent!: string;

	@Prop({
		default: false
	})
	readonly isRoot!: boolean;

	get item() {
		return this.$props.data[this.$props.tree.key];
	}

	get menuListCssClasses() {
		return {
			'styleguidist-navigation__list_border-left': this.item && this.item.title && !this.item.hidden
		};
	}

	toggleSubMenu() {
		const navState = this.item.isActive;

		this.hideAllSubMenus();
		this.updateNavigationItem({
			id: this.item.key,
			data: {
				isActive: !navState
			}
		});

		this.$emit('navigation:activated');
	}

	setNewCurrentNav() {
		if (this.item) {
			this.updateNavigationItem({
				id: this.item.key,
				data: {
					isActive: true
				}
			});

			this.$emit('navigation:activated');
		}
	}
}
